import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M76.18 1.82007H6.40998C6.40998 1.82007 -1.45002 15.3501 2.42998 30.2501C7.54998 49.8901 26.39 55.5501 15.16 65.5701C15.16 65.5701 23.25 65.3001 26.22 60.7601C26.22 60.7601 25.72 64.7701 23.74 67.0401C23.74 67.0401 34.97 69.3101 41.08 63.0301C41.5 62.6001 41.69 62.5801 42.07 63.0301C47.02 68.9101 56.93 66.6401 56.93 66.6401C55.77 64.2201 56.24 62.2001 56.24 62.2001C58.89 68.3701 67.42 66.9001 67.42 66.9001C56.19 56.8801 74.77 47.3601 79.89 27.7101C83.78 12.8201 76.18 1.82007 76.18 1.82007Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
